import React, {Component} from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import zipupload from './pages/zipupload'
import './App.css'
import 'antd/dist/antd.css';
import { Menu } from 'semantic-ui-react'
import axios from 'axios'
import 'semantic-ui-css/semantic.min.css';

const Home = () => (
  <div>
    <h2>Home</h2>
  </div>
)

class BasicExample extends Component {
  state = {}

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  componentDidMount = () => {
    // axios.defaults.baseURL = 'http://0.0.0.0:47001'
    // axios.defaults.baseURL = 'http://localhost:3000'
    axios.defaults.baseURL = 'https://merch.gsmsaleskc.com'
    this.setState({activeItem: window.location.pathname.substring(1)})
  }

  render() {
    const { activeItem } = this.state

    return (
      <Router>
        <div style={{overflow: 'hidden', height: '950px'}}>
          <Menu className="main-Navigation">
            <Link to="/Home"><Menu.Item header onClick={this.handleItemClick}>GSM - Merch</Menu.Item></Link>
            <Link to="/"><Menu.Item name='zipupload' active={true} content="Zip Upload" onClick={this.handleItemClick} /></Link>
          </Menu>

          <Route exact path="/Home" component={Home}/>
          <Route path="/" component={zipupload}/>
        </div>
      </Router>
    )
  }

}

/*const BasicExample = () => (
  <Router>
    <div>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/chart">Chart</Link></li>
      </ul>

      <hr/>

      <Route exact path="/" component={Home}/>
      <Route path="/about" component={About}/>
      <Route path="/chart" component={chart}/>
    </div>
  </Router>
)*/
export default BasicExample



// WEBPACK FOOTER //
// ./src/App.js